'use client'
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/common/BookingWrapper.tsx
import { useRef } from "react";
import { AnimatePresence, motion } from "motion/react";
import { twMerge } from "tailwind-merge";
import { useRouter } from "@wbk/config";
import { jsx } from "react/jsx-runtime";
var BookingWrapper = (_a) => {
  var _b = _a, {
    initialMode,
    mode,
    modes = ["calendar", "tickets", "addons", "summary"],
    className,
    children,
    ref
  } = _b, props = __objRest(_b, [
    "initialMode",
    "mode",
    "modes",
    "className",
    "children",
    "ref"
  ]);
  const { locale } = useRouter();
  const direction = (locale == null ? void 0 : locale.startsWith("ar")) ? -100 : 100;
  const nextModeRef = useRef(initialMode || modes[0]);
  const prevModeRef = useRef(initialMode || modes[0]);
  return /* @__PURE__ */ jsx(AnimatePresence, { initial: false, mode: "wait", children: /* @__PURE__ */ jsx(
    motion.div,
    __spreadProps(__spreadValues({
      ref,
      className: twMerge(
        "grow overflow-hidden transition-all data-[overflow=true]:overflow-visible lg:space-y-1",
        className
      ),
      initial: "enter",
      "data-overflow": mode === "addons",
      animate: "center",
      exit: "exit",
      custom: { mode },
      variants: {
        enter: ({ mode: mode2 }) => {
          nextModeRef.current = mode2;
          const prevModeIndex = modes.indexOf(prevModeRef.current);
          const nextModeIndex = modes.indexOf(nextModeRef.current);
          const sign = Math.sign(nextModeIndex - prevModeIndex);
          return {
            x: direction * sign,
            opacity: 0
          };
        },
        center: ({ mode: mode2 }) => {
          prevModeRef.current = mode2;
          return {
            x: 0,
            opacity: 1
          };
        },
        exit: () => {
          const prevModeIndex = modes.indexOf(prevModeRef.current);
          const nextModeIndex = modes.indexOf(nextModeRef.current);
          const sign = Math.sign(prevModeIndex - nextModeIndex);
          return {
            x: sign * direction,
            opacity: 0
          };
        }
      },
      transition: { duration: 0.2 }
    }, props), {
      children
    }),
    `${mode}-${direction}`
  ) }, mode);
};
var BookingWrapper_default = BookingWrapper;

// src/components/common/PaymentFailed.tsx
import { useEffect, useState } from "react";
import { Button as Button2, Typography as Typography2 } from "@wbk/ui";
import { Exception } from "@wbk/logger";
import { readCookie } from "@wbk/utils";
import { Link as Link2, useRouter as useRouter3, useTranslation as useTranslation2 } from "@wbk/config";
import { ExclamationTriangleIcon } from "@wbk/svg";
import { useAnalytics } from "@wbk/analytics";

// src/components/common/WbkContactUs.tsx
import { Link, Trans, useRouter as useRouter2, useTranslation } from "@wbk/config";
import { SupportHeadphone, TelephoneIcon, Whatsapp } from "@wbk/svg";
import { Button, ResponsiveModal, Typography } from "@wbk/ui";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var WbkContactUs = ({ render }) => {
  const { t } = useTranslation("ticketing_common");
  const { locale } = useRouter2();
  return /* @__PURE__ */ jsx2(
    ResponsiveModal,
    {
      title: /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        t("ticketing_common:contact_us.title"),
        /* @__PURE__ */ jsx2(Typography, { as: "div", color: "text-secondary", children: t("ticketing_common:contact_us.description") })
      ] }),
      size: "2xl",
      cancel: false,
      action: {
        label: t("ticketing_common:contact_us.submit"),
        onClick: () => window.location.href = `https://wbk.zendesk.com/hc/${locale}/requests/new`
      },
      render: render ? render : ({ open }) => /* @__PURE__ */ jsx2("div", { className: "space-y-4", children: /* @__PURE__ */ jsxs(
        Button,
        {
          className: "space-x-1 p-1 rtl:space-x-reverse",
          type: "button",
          theme: "white",
          shape: "text",
          onClick: open,
          children: [
            /* @__PURE__ */ jsx2(SupportHeadphone, { className: "text-text-secondary h-6 w-6" }),
            /* @__PURE__ */ jsx2(Typography, { variant: "link-L", color: "text-secondary", children: t("ticketing_common:contact_us.need_help") })
          ]
        }
      ) }),
      body: () => /* @__PURE__ */ jsx2(ContactInfoBody, {})
    }
  );
};
var ContactInfoBody = () => {
  const { t } = useTranslation("ticketing_common");
  const { locale } = useRouter2();
  return /* @__PURE__ */ jsxs("div", { className: "space-y-6", children: [
    /* @__PURE__ */ jsxs("div", { className: "border-paper space-y-4 rounded-md border p-4", children: [
      /* @__PURE__ */ jsx2(Typography, { variant: "heading-S", children: t("ticketing_common:contact_us.working_hours") }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex justify-between", children: [
          /* @__PURE__ */ jsx2(Typography, { children: t("ticketing_common:contact_us.all_year") }),
          /* @__PURE__ */ jsx2(Typography, { children: t("ticketing_common:contact_us.all_year_time") })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex justify-between", children: [
          /* @__PURE__ */ jsx2(Typography, { children: t("ticketing_common:contact_us.ramadan_day") }),
          /* @__PURE__ */ jsx2(Typography, { children: t("ticketing_common:contact_us.ramadan_day_time") })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "flex justify-between", children: [
          /* @__PURE__ */ jsx2(Typography, { children: t("ticketing_common:contact_us.ramadan_night") }),
          /* @__PURE__ */ jsx2(Typography, { children: t("ticketing_common:contact_us.ramadan_night_time") })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ jsx2(TelephoneIcon, {}),
      /* @__PURE__ */ jsx2("div", { className: "flex flex-1 justify-between", children: /* @__PURE__ */ jsxs(Trans, { i18nKey: "ticketing_common:contact_us.phone", children: [
        /* @__PURE__ */ jsx2(Typography, { variant: "body-L", strong: true }),
        /* @__PURE__ */ jsx2(
          Typography,
          {
            as: "a",
            href: "tel:+966115048568",
            target: "_blank",
            variant: "link-L",
            dir: "ltr",
            className: "underline"
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-3", children: [
      /* @__PURE__ */ jsx2(Whatsapp, { className: "h-6 w-6" }),
      /* @__PURE__ */ jsx2("div", { className: "flex flex-1 justify-between", children: /* @__PURE__ */ jsxs(Trans, { i18nKey: "ticketing_common:contact_us.whatsapp", children: [
        /* @__PURE__ */ jsx2(Typography, { variant: "body-L", strong: true }),
        /* @__PURE__ */ jsx2(
          Typography,
          {
            as: "a",
            href: "https://wa.me/966115048568",
            target: "_blank",
            variant: "link-L",
            dir: "ltr",
            className: "underline"
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ jsx2("div", { className: "flex flex-col items-start space-y-1", children: /* @__PURE__ */ jsxs(Trans, { i18nKey: "ticketing_common:contact_us.faq", children: [
      /* @__PURE__ */ jsx2(Typography, {}),
      /* @__PURE__ */ jsx2(
        Button,
        {
          theme: "transparent",
          shape: "text",
          className: "p-0 underline",
          as: Link,
          href: `https://wbk.zendesk.com/hc/${locale}`
        }
      )
    ] }) })
  ] });
};
var WbkContactUs_default = WbkContactUs;

// src/components/common/PaymentFailed.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var PaymentFailed = () => {
  var _a, _b;
  const [lastBookPage, setLastBookPage] = useState("/");
  const { locale } = useRouter3();
  const { t } = useTranslation2("ticketing_booking");
  const searchParams = new URLSearchParams(window.location.search);
  const reason = (_b = (_a = searchParams.get("error")) == null ? void 0 : _a.split(":")) == null ? void 0 : _b[1];
  const { purchaseFailed } = useAnalytics();
  useEffect(() => {
    const fireSentry = setTimeout(() => {
      const error = new Error(reason || "Reason not found in URL");
      error.name = "PaymentFailedException";
      new Exception({
        error,
        name: "PaymentFailedException",
        context: {
          extra: { reason: reason || "EMPTY" },
          tags: { journey: "checkout" }
        }
      });
    }, 500);
    return () => clearTimeout(fireSentry);
  }, [reason]);
  useEffect(() => {
    purchaseFailed({ reason });
    setLastBookPage(readCookie("last_book_page") || "/");
  }, []);
  return /* @__PURE__ */ jsxs2("section", { className: "container py-20", children: [
    /* @__PURE__ */ jsx3(ExclamationTriangleIcon, { className: "h-16 w-16" }),
    /* @__PURE__ */ jsxs2("div", { className: "mt-2", children: [
      /* @__PURE__ */ jsx3(Typography2, { variant: "heading-XL", className: "mb-2", children: t("ticketing_booking:payment_failed") }),
      /* @__PURE__ */ jsx3(Typography2, { as: "div", className: "max-w-3xl py-2", children: reason ? /* @__PURE__ */ jsxs2("span", { className: "py-3", children: [
        /* @__PURE__ */ jsx3(Typography2, { children: t("ticketing_booking:reason_bank") }),
        /* @__PURE__ */ jsx3(Typography2, { color: "error", children: `${reason}` })
      ] }) : t("ticketing_booking:payment_information_right") }),
      /* @__PURE__ */ jsx3(WbkContactUs_default, {}),
      /* @__PURE__ */ jsxs2("div", { className: "mt-4 flex gap-4 py-4", children: [
        /* @__PURE__ */ jsx3(Button2, { as: Link2, href: lastBookPage, theme: "action", children: t("ticketing_booking:try_again") }),
        /* @__PURE__ */ jsx3(Button2, { as: Link2, href: `/${locale}/explore`, shape: "outlined", theme: "action", children: t("ticketing_booking:explore_events") })
      ] })
    ] })
  ] });
};
var PaymentFailed_default = PaymentFailed;

export {
  BookingWrapper_default,
  WbkContactUs_default,
  PaymentFailed_default
};
//# sourceMappingURL=chunk-4JT4AM7Z.mjs.map